import { render, staticRenderFns } from "./SupplierSizeAutocomplete.vue?vue&type=template&id=38cbe1d3"
import script from "./SupplierSizeAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports